// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","sidePanelCard":"BacklinksContent_sidePanelCard__1Y_4H"};